import { render, staticRenderFns } from "./Negotiators.vue?vue&type=template&id=18f5dfdc&scoped=true"
import script from "./Negotiators.vue?vue&type=script&lang=js"
export * from "./Negotiators.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f5dfdc",
  null
  
)

export default component.exports